import { useState } from "react";
import Header from "../../Components/Header";
import { Disclosure, Transition } from "@headlessui/react";
import { SearchInput } from "../../Components/Elements/CustomInputs";
import { classNames } from "../../utils/utils";
import { ChevronUpIcon, FirstIcon, SecondIcon, ThirdIcon, FourthIcon, FifthIcon } from "../../utils/iconFactory";

export default function Help() {
  const [searchQuery, setSearchQuery] = useState<string>("");

  return (
    <>
      <Header>
        <div id='documents-custom-header' className="flex items-center justify-center">
          <h2 id='documents-header-text' className="text-textMain text-style-h2">Segítségközpont</h2>
        </div>
      </Header>
      <div className="flex flex-1 flex-col bg-backgroundWhite h-full relative overflow-y-auto no-scrollbar">
        <div className="min-h-[86px] w-full" />

        <main className="flex flex-1 flex-col items-center w-full rounded-t-[16px] p-10 bg-backgroundWhite">
          <div className="relative flex flex-col gap-6 w-full items-center">
            <h1 className="text-center text-textMain text-style-h1">Miben segíthetek?</h1>
            <div className="w-[420px] item-center">
              <SearchInput
                type="text"
                value={searchQuery}
                customAction={() => setSearchQuery("")}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Keresés..."
                spellCheck={false}
                className=""
              />
              <img src="/robot1.png" className="absolute left-0 top-0 h-[172px] w-[182px] -mx-10 -translate-x-[43px]" />
            </div>
          </div>
          <div id='panels' className="flex flex-col gap-6 pt-14 w-full">
            {(("Így használd az AIDA-t").toUpperCase().includes(searchQuery.toUpperCase()) || searchQuery === "") &&
              <Disclosure as="div" id='igy-hasznald-az-aidat'>
                {({ open }) => (
                  <>
                    <Disclosure.Button className={classNames("group flex w-full justify-between px-6 py-[23px]",
                      open ? "rounded-t-[16px] border-t border-x" : "rounded-[16px] border delay-[550ms] transition-rounded",
                      "border-backgroundDarkGray",
                      "bg-backgroundWhite text-left text-textMain text-style-sub1",
                      "card-drop-shadow card-hover-drop-shadow")}>
                      <span>Így használd az AIDA-t</span>
                      <ChevronUpIcon
                        className={`${
                          open ? 'rotate-180 transform duration-300' : 'rotate-0 transform duration-300'
                        } h-8 w-8 text-gray150 group-hover:text-primaryActionAltHover fill-current`}
                      />
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      className="overflow-hidden"
                      enter="transition-all ease-in-out duration-[900ms] "
                      enterFrom="transform  max-h-0"
                      enterTo="transform  max-h-[1000px]"
                      leave="transition-all ease-in-out duration-[600ms]"
                      leaveFrom="transform  max-h-[1000px]"
                      leaveTo="transform  max-h-0"
                    >
                      <Disclosure.Panel className="px-6 pb-[26px] bg-backgroundWhite rounded-b-[16px] border-x border-b border-backgroundDarkGray">
                        <div className="flex flex-col gap-2">
                          <p className="text-textMain text-style-body2">Az AIDA, AI marketing asszisztens használata egyszerűbb, mint gondolnád. </p>
                          <p className="text-textMain text-style-body2">Nincs más teendőd, mint kiválasztani azt a területet, amiben segítségre van szükséged. Miután megadtad a terméknevet, az AIDA  azonnal el is végzi a feladatot.</p>
                          <p className="text-textMain text-style-body2">Nézd meg az alábbi videót, amiben bemutatjuk, hogy hozhatod ki az AIDA-ból a legtöbbet!</p>
                        </div>
                        <div className="pt-[23px]">
                          <iframe className="h-[282px] w-[575px]" src='https://www.youtube.com/embed/qt40RsFT15M' title='Youtube Video' allowFullScreen></iframe>
                        </div>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            }
            {(("Szerkesztő").toUpperCase().includes(searchQuery.toUpperCase()) || searchQuery === "") &&
              <Disclosure as="div" id='szerkeszto'>
                {({ open }) => (
                  <>
                    <Disclosure.Button className={classNames("group flex w-full justify-between px-6 py-[23px] relative",
                      open ? "rounded-t-[16px] border-t border-x" : "rounded-[16px] border delay-[550ms] transition-rounded",
                      "border-backgroundDarkGray",
                      "bg-backgroundWhite text-left text-textMain text-style-sub1",
                      "card-drop-shadow card-hover-drop-shadow")}>
                      <span>Szerkesztő</span>
                      <ChevronUpIcon
                        className={`${
                          open ? 'rotate-180 transform duration-300' : 'rotate-0 transform duration-300'
                        } h-8 w-8 text-gray150 group-hover:text-primaryActionAltHover fill-current`}
                      />
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      className="overflow-hidden"
                      enter="transition-all ease-in-out duration-[900ms] "
                      enterFrom="transform  max-h-0"
                      enterTo="transform  max-h-[1000px]"
                      leave="transition-all ease-in-out duration-[600ms]"
                      leaveFrom="transform  max-h-[1000px]"
                      leaveTo="transform  max-h-0"
                    >
                      <Disclosure.Panel className="px-6 pb-[26px] bg-backgroundWhite rounded-b-[16px] border-x border-b border-backgroundDarkGray">
                        <div className="flex flex-col gap-4 text-style-body2 text-textMain">
                          <p>A Szerkesztőben AIDA segítségével tudsz szöveget generálni, illetve korábbi dokumentumjaidat is tudod szerkeszteni.</p>
                          <ol className='space-y-2'>
                            <li key={"1"} className='flex items-center' >{<FirstIcon className="mr-2 flex-none h-10 w-10"/>} Válaszd ki, hogy milyen segítségre van szükséged.</li>
                            <li key={"2"} className='flex items-center' >{<SecondIcon className="mr-2 flex-none h-10 w-10" />} Adj meg egy terméknevet  (pl.: Fiskars 1001424 Metszőolló) és egy rövid leírást róla a pontos eredményhez.</li>
                            <li key={"3"} className='flex items-center' >{<ThirdIcon className="mr-2 flex-none h-10 w-10" />} Kattints a “Generálás” gombra és azonnal érkezik a válasz.</li>
                            <li key={"4"} className='flex items-center' >{<FourthIcon className="mr-2 flex-none h-10 w-10" />} Vidd át a generált szöveget a szerkesztői felületre a képernyőn megjelenő nyíl gomb segítségével.</li>
                            <li key={"5"} className='flex items-center' >{<FifthIcon className="mr-2 flex-none h-10 w-10" />} Nevezd el a dokumentumot. szerkeszd, majd mentsd el.</li>
                          </ol>

                          <div className="pt-2">
                            <p className='text-style-body2-bold'>Szöveg generálás kiválaszott feladathoz:</p>
                            <p>A termék leírása mezőben add meg a terméked nevét, amelyhez szöveget szeretnél generáltatni.  Kerülendő és használandó szavakat, kifejezéseket is megadhatsz, illetve beállíthatsz maximum karakterszámot is.</p>
                          </div>

                          <div>
                            <p className='text-style-body2-bold'>Másikat választok:</p>
                            <p>A “Másikat választok” gomb segítségével egy új feladatot/témakört tudsz kiválasztani, amihez szöveget szeretnél generálni.</p>
                          </div>

                          <div>
                            <p className='text-style-body2-bold'>Szöveg szerkesztése:</p>
                            <p>A szerkesztői panelben átírhatod és formázhatod a leírást. Amíg nem nevezed el a dokumentumot, addig nem tudod elmenteni.</p>
                            <p>Az elmentett dokumentum automatikusan megtalálható lesz a “Dokumentumok” menüpontban.</p>
                          </div>

                          <div>
                            <p className='text-style-body2-bold'>Új feladat létrehozása:</p>
                            <p>Kattints erre a gombra, ha egy teljesen új dokumentumot/feladatot szeretnél létrehozni, nem pedig egy meglévőt felülírni.</p>
                          </div>

                          <div>
                            <p className='text-style-body2-bold'>Korábbi dokumentum betöltése:</p>
                            <p>Ha egy korábbi dokumentumot szeretnél módosítani, kattints a “Korábbi dokumentum betöltése és szerkesztése” gombra és válaszd ki a szerkesztendő dokumentumot. Változtatások mentése után a dokumentum felülíródik, így a korábbi verziók nem lesznek elérhetők. Ha inkább más néven szeretnéd elmenteni a módosított változatot, nevezd át a dokumentumot.</p>
                          </div>
                        </div>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            }
            {(("Dokumentumok").toUpperCase().includes(searchQuery.toUpperCase()) || searchQuery === "") && 
              <Disclosure as="div" id='dokumentumok'>
                {({ open }) => (
                  <>
                    <Disclosure.Button className={classNames("group flex w-full justify-between px-6 py-[23px]",
                      open ? "rounded-t-[16px] border-t border-x" : "rounded-[16px] border delay-[550ms] transition-rounded",
                      "border-backgroundDarkGray",
                      "bg-backgroundWhite text-left text-textMain text-style-sub1",
                      "card-drop-shadow card-hover-drop-shadow")}>
                      <span>Dokumentumok</span>
                      <ChevronUpIcon
                        className={`${
                          open ? 'rotate-180 transform duration-300' : 'rotate-0 transform duration-300'
                        } h-8 w-8 text-gray150 group-hover:text-primaryActionAltHover fill-current`}
                      />
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      className="overflow-hidden"
                      enter="transition-all ease-in-out duration-[900ms] "
                      enterFrom="transform  max-h-0"
                      enterTo="transform  max-h-[1000px]"
                      leave="transition-all ease-in-out duration-[600ms]"
                      leaveFrom="transform  max-h-[1000px]"
                      leaveTo="transform  max-h-0"
                    >
                      <Disclosure.Panel className="px-6 pb-[26px] bg-backgroundWhite rounded-b-[16px] border-x border-b border-backgroundDarkGray text-style-body2 text-textMain">
                        <div className="flex flex-col gap-4">
                          <p>A dokumentumok olyan tartalmak, amelyeket az egyes feladatok elvégzése után menthetsz el, vagy szerkeszthetsz - akár utólag is. </p>
                          <p>Kétféleképpen hozhatsz létre új dokumentumot:
                            <ul className='list-disc list-outside ml-[21px]'>
                              <li>Elvégeztetsz az AIDA-val egy feladatot, majd elmented.</li>
                              <li>Létrehozol egy új, üres dokumentumot, majd ehhez választasz feladatot</li>
                            </ul>
                          </p>
                          <p>A dokumentumokat szerkesztheted, letöltheted vagy másolhatod is a kapcsolódó ikonokra kattintva.</p>
                          <p>Törlés esetén a dokumentum nem visszaállítható.</p>
                        </div>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            }
            {(("Profil").toUpperCase().includes(searchQuery.toUpperCase()) || searchQuery === "") && 
              <Disclosure as="div" id='profil'>
                {({ open }) => (
                  <>
                    <Disclosure.Button className={classNames("group flex w-full justify-between px-6 py-[23px]",
                      open ? "rounded-t-[16px] border-t border-x" : "rounded-[16px] border delay-[550ms] transition-rounded",
                      "border-backgroundDarkGray",
                      "bg-backgroundWhite text-left text-textMain text-style-sub1",
                      "card-drop-shadow card-hover-drop-shadow")}>
                      <span>Profil</span>
                      <ChevronUpIcon
                        className={`${
                          open ? 'rotate-180 transform duration-300' : 'rotate-0 transform duration-300'
                        } h-8 w-8 text-gray150 group-hover:text-primaryActionAltHover fill-current`}
                      />
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      className="overflow-hidden"
                      enter="transition-all ease-in-out duration-[900ms] "
                      enterFrom="transform  max-h-0"
                      enterTo="transform  max-h-[1000px]"
                      leave="transition-all ease-in-out duration-[600ms]"
                      leaveFrom="transform  max-h-[1000px]"
                      leaveTo="transform  max-h-0"
                    >
                      <Disclosure.Panel className="px-6 pb-[26px] bg-backgroundWhite rounded-b-[16px] border-x border-b border-backgroundDarkGray">
                        <div className="flex flex-col gap-4 text-style-body2 text-textMain">
                          <p>A profilban található adatok a Shoprenter webáruházadban megadott adatok alapján jelennek meg.</p>
                          <p>Az előfizetéssel kapcsolatos információkat is megtalálod ebben a menüpontban, amelyet meg tudsz változtatni vagy le tudsz mondani. A lemondást követően nem fogsz tudni hozzáférni bizonyos funkciókhoz.</p>
                        </div>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            }
            {(("Gyakori kérdések").toUpperCase().includes(searchQuery.toUpperCase()) || searchQuery === "") && 
              <Disclosure as="div" id='gyakori-kerdesek'>
                {({ open }) => (
                  <>
                    <Disclosure.Button className={classNames("group flex w-full justify-between px-6 py-[23px]",
                      open ? "rounded-t-[16px] border-t border-x" : "rounded-[16px] border delay-[550ms] transition-rounded",
                      "border-backgroundDarkGray",
                      "bg-backgroundWhite text-left text-textMain text-style-sub1",
                      "card-drop-shadow card-hover-drop-shadow")}>
                      <span>Gyakori kérdések</span>
                      <ChevronUpIcon
                        className={`${
                          open ? 'rotate-180 transform duration-300' : 'rotate-0 transform duration-300'
                        } h-8 w-8 text-gray150 group-hover:text-primaryActionAltHover fill-current`}
                      />
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      className="overflow-hidden"
                      enter="transition-all ease-in-out duration-[900ms] "
                      enterFrom="transform  max-h-0"
                      enterTo="transform  max-h-[1000px]"
                      leave="transition-all ease-in-out duration-[600ms]"
                      leaveFrom="transform  max-h-[1000px]"
                      leaveTo="transform  max-h-0"
                    >
                      <Disclosure.Panel className="px-6 pb-[26px] bg-backgroundWhite rounded-b-[16px] border-x border-b border-backgroundDarkGray">
                        <div className="flex flex-col gap-6 text-style-body2 text-textMain">
                          <div className="flex flex-col gap-2">
                            <p className='text-style-body2-bold'>Mi az AIDA?</p>
                            <p>lorem ipsum</p>
                          </div>

                          <div className="flex flex-col gap-2">
                            <p className='text-style-body2-bold'>Hogy használható?</p>
                            <p>lorem ipsum</p>
                          </div>

                          <div className="flex flex-col gap-2">
                            <p className='text-style-body2-bold'>Mennyibe kerül?</p>
                            <p>lorem ipsum</p>
                          </div>

                          <div className="flex flex-col gap-2">
                            <p className='text-style-body2-bold'>Milyen újdonságok várhatóak?</p>
                            <p>lorem ipsum</p>
                          </div>

                          <div className="flex flex-col gap-2">
                            <p className='text-style-body2-bold'>Hogy tudom meghosszabbítani, vagy lemondani az előfizetésem?</p>
                            <p>lorem ipsum</p>
                          </div>
                        </div>
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            }
          </div>
          <div id='footer' className="flex flex-col text-center pt-[60px]">
            <p className="text-textMain text-style-body1">Nem találsz választ a kérdésedre?</p>
            <p className="text-textMain text-style-body1">Írj egy üzenetet a kérdéseddel vagy a probléma leírásával az <span className="font-bold">aidaappapp@gmail.com</span> e-mail címre.</p>
          </div>
        </main>
      </div>
    </>
  )
}